<template>
  <div class="banner-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <!-- <div class="filter-box">
          <div class="filter">
            <div class="filter-item">
              <el-input
                type="number"
                placeholder="用户id"
                v-model="filter.uid"
                size="small"
                class="input"
              >
              </el-input>
            </div>
            <div class="btn-box">
              <button class="search" @click="search">搜索</button>
              <button class="reset" @click="reset">重置</button>

              <button
                class="search"
                @click="order2excel"
                style="margin-left: 20px;"
              >
                导出
              </button>
            </div>
          </div>
        </div> -->
        <el-table
          :data="list"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column 
            prop="uid" 
            align="center" 
            label="发布人ID"
          ></el-table-column>
          <el-table-column
            prop="nickname"
            align="center"
            label="昵称"
          ></el-table-column>
          <el-table-column
            prop="created"
            align="center"
            label="发布时间"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <div
              slot-scope="scope"
              style="display: flex;justify-content: center;"
            >
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="toDetail(scope.row)"
                >
                  查看
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
        <!-- 分页按钮 -->
      </div>
      <div class="footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
import myUtils from '../../components/common/whatever2excel';
import { staticImg, AREA_OSS } from '@/config'; // oss 图片地址
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      loading: 0, // 加载中
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '意见反馈'
      },
      filter: {
        uid: null
      },
      list: [], // 轮播列表
    };
  },
  mounted() {
    // 获取列表
    this.getFeedbackList();
  },
  computed: {},
  methods: {
    // 表格序号
    tableIndex(index) {
      return ++index;
    },
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getFeedbackList();
    },
    // 获取轮播列表
    getFeedbackList() {
      this.loading++;
      this.httpGet(this.$root.getFeedbackList, {
        page: this.currentPage,
        size: this.size,
        ...this.filter
      }).then(
        (res) => {
          this.loading--;
          this.list = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    search(){
      this.currentPage = 1;
      this.getFeedbackList();
    },
    reset(){
      this.filter = {
        // 过滤条件
        uid: null
      };
      this.date = [];
      this.getFeedbackList();
    },
    uidFormat(val) {
      if (!val) return '';
      let str = val + '';
      let length = 6 - str.length;
      for (let i = 0; i < length; i++) {
        str = '0' + str;
      }
      return 'QY' + str;
    },
    toDetail(row){
      this.$router.push({
        name: 'feedbackDetail',
        query: {
          id: row.id
        }
      });
    },
    async order2excel() {
      if(!(await this.exportLog())) return;
      this.loading++;
      let userList = [];
      let totalPage = null;
      let data = {
        page: this.currentPage,
        size: this.size,
        ...this.filter
      };
      await this.httpGet(this.$root.getFeedbackList, data).then(
        (res) => {
          this.loading--;
          totalPage = Math.ceil(parseInt(res.total) / this.size);
        },
        () => {
          this.loading--;
        }
      );
      this.showProgressDialog = true;
      this.progress = 0;
      await this.getAllPages(totalPage, userList).then(
        () => {
          this.showProgressDialog = false;
          this.jsonFormatAndToExcel(userList);
        },
        (err) => {
          console.error(err);
          this.showProgressDialog = false;
        }
      );
    },
    async getAllPages(totalPage, list) {
      for (let i = 1; i <= totalPage; i++) {
        let data = {
          page: i,
          size: this.size,
          ...this.filter
        };
        await this.httpGet(this.$root.getFeedbackList, data).then((res) => {
          list.push(...res.list);
          this.progress = Math.floor((i / totalPage) * 100);
          console.log('page' + i, list.length);
        });
        // console.log(5555, list);
      }
    },
    jsonFormatAndToExcel(list) {
      let formatList = [];
      list.forEach((item) => {
        let obj = {
          反馈人昵称: item.nickname,
          反馈人ID: this.uidFormat(item.uid),
          反馈时间: item.created,
        };
        formatList.push(obj);
      });
      myUtils.json2excel(formatList);
      // this.exportLog();
    },
    exportLog(){
      this.loading++;
      return this.httpGet(this.$root.getFeedbackList + '/export', {}).then(
        (res) => {
          this.loading--;
          return true;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
          return false;
        }
      );
    },
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.banner-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      // 按钮
      .btn {
        // width: 100px;
        display: inline-block;
        padding: 0 30px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
        // margin: 16px 0;
      }

      .tip {
        margin-left: 32px;
        color: #40B98F;
      }

      // 表格按钮
      .table-btn {
        width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
      }

      .table-img {
        height: 70px;
        width: auto;
      }
    }
  }
}
</style>
